module.exports = __webpack_public_path__ + "img/zz.60a92569.png";